module.exports = __webpack_public_path__ + "img/08.5abfb9eb.png";